import {Box, Typography} from '@mui/material';
import styled from 'styled-components';

const StyledTypography = styled(Typography)`
	b {
		font-weight: 600;
	}
`;

const NextStepsContainer = styled(Box)`
	width: 100%;
`;

const NextStepsList = styled.ul`
	margin: ${({theme}) => theme.spacing(1, 0, 0)};
	padding-left: ${({theme}) => theme.spacing(2.5)};
	list-style: disc;

	li:not(:last-child) {
		margin-bottom: ${({theme}) => theme.spacing(0.5)};
	}
`;

export {NextStepsContainer, NextStepsList, StyledTypography};
